import { Chart } from 'react-chartjs-2';

Chart.defaults.font.family = 'IRANSans';
Chart.defaults.responsive = true;

const rand = () => Math.round(Math.random() * 20 - 10);

export const bars = {
    labels: ['1', '2', '3', '4', '5', '6'],

    datasets: [
        {
            label: 'فروش',
            data: [12, 19, 3, 5, 2, 3],
            backgroundColor: 'rgb(254, 54, 56)',
        },
        {
            label: 'محصولات',
            data: [2, 3, 20, 5, 1, 4],
            backgroundColor: 'rgb(35, 64, 231)',
        },
        {
            label: 'مشتری ها',
            data: [3, 10, 13, 15, 22, 30],
            backgroundColor: 'rgb(138, 43, 226)',
        },
    ],

    options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                },
            ],
        },
    },
};

export const line = {
    labels: ['1', '2', '3', '4', '5', '6'],
    datasets: [
        {
            label: 'درآمد ماهیانه',
            data: [10, 5, 13, 12, 5, 28],
            borderColor: 'rgba(255, 99, 132, 1)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
        },
    ],

    options: {
        responsive: true,
        maintainAspectRatio: false,
    },
};

export const polar = {
    labels: ['لباس مردانه', 'لباس زنانه', 'لباس کودک'],

    datasets: [
        {
            data: [8, 19, 13],
            backgroundColor: [
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(35, 64, 231, 0.2)',
            ],
            borderColor: [
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(35, 64, 231, 1)',
            ],
            borderWidth: 2,
        },
    ],

    options: {
        responsive: true,
        maintainAspectRatio: false,
    },
};

export const doughnut = {
    labels: ['ارسالی ها', 'فروش', 'مشتری ها', 'درآمد ماهیانه'],

    datasets: [
        {
            label: '# of Votes',
            data: [12, 19, 3, 5],
            backgroundColor: [
                'rgba(254, 54, 56, 0.5)',
                'rgba(35, 64, 231, 0.5)',
                'rgba(255, 206, 86, 0.5)',
                'rgba(0, 206, 86, 0.5)',
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
            ],
            borderWidth: 1,
        },
    ],

    options: {
        responsive: true,
        maintainAspectRatio: false,
    },
};

export const verBars = {
    labels: ['قرمز', 'آبی', 'زرد', 'سبز', 'بنفش', 'نارنجی'],

    datasets: [
        {
            label: 'نمودار افقی',

            data: [12, 19, 3, 5, 2, 3],
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
            ],
            borderWidth: 1,
        },
    ],

    options: {
        indexAxis: 'y',
        // Elements options apply to all of the options unless overridden in a dataset
        // In this case, we are setting the border of each horizontal bar to be 2px wide
        elements: {
            bar: {
                borderWidth: 2,
            },
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
        },
    },
};

export const line2 = {
    labels: ['1', '2', '3', '4', '5', '6'],
    datasets: [
        {
            label: 'نمودار خطی',
            data: [12, 19, 3, 5, 2, 3],
            fill: false,
            backgroundColor: 'rgb(255, 99, 132)',
            borderColor: 'rgba(255, 99, 132, 0.2)',
        },
    ],

    options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                },
            ],
        },
    },
};

export const pie = {
    labels: ['قرمز', 'آبی', 'زرد', 'سبز', 'بنفش', 'نارنجی'],
    datasets: [
        {
            label: '# of Votes',
            data: [12, 19, 3, 5, 2, 3],
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
            ],
            borderWidth: 1,
        },
    ],

    options: {
        responsive: true,
        maintainAspectRatio: false,
    },
};

export const radar = {
    labels: ['محصول 1', 'محصول 2', 'محصول 3', 'محصول 4', 'محصول 5', 'محصول 6'],
    datasets: [
        {
            label: 'نمودار راداری',
            data: [2, 9, 3, 5, 2, 3],
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 1,
        },
    ],

    options: {
        responsive: true,
        maintainAspectRatio: false,
        scale: {
            ticks: { beginAtZero: true },
        },
    },
};

export const dynamicBars = () => ({
    labels: ['قرمز', 'آبی', 'زرد', 'سبز', 'بنفش', 'نارنجی'],
    datasets: [
        {
            label: 'نمودار متغییر',
            data: [rand(), rand(), rand(), rand(), rand(), rand()],
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
            ],
            borderWidth: 1,
        },
    ],

    options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                },
            ],
        },
    },
});

export const multiBars = {
    labels: ['فروردین', 'اسفند', 'بهمن', 'دی', 'آذر', 'آبان', 'مهر'],
    datasets: [
        {
            type: 'line',
            label: 'نمودار ۳',
            borderColor: 'rgb(54, 162, 235)',
            borderWidth: 2,
            fill: false,
            data: [rand(), rand(), rand(), rand(), rand(), rand()],
        },
        {
            type: 'bar',
            label: 'نمودار ۲',
            backgroundColor: 'rgb(255, 99, 132)',
            data: [rand(), rand(), rand(), rand(), rand(), rand(), rand()],
            borderColor: 'white',
            borderWidth: 2,
        },
        {
            type: 'bar',
            label: 'نمودار ۱',
            backgroundColor: 'rgb(75, 192, 192)',
            data: [rand(), rand(), rand(), rand(), rand(), rand(), rand()],
        },
    ],

    options: {
        responsive: true,
        maintainAspectRatio: false,
    },
};
